/* eslint-disable no-param-reassign */
import React, { createContext, useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import LazyLoad from 'vanilla-lazyload';

// Create a new React context
const Context = createContext();

const options = () => ({
  elements_selector: '.is-lazyload',
  callback_error: (element) => {
    element.src = `/images/image-404.png`;
  },
});

// Export the context provider
export const LazyLoadProvider = ({ children }) => {
  const [lazyLoad, setLazyLoad] = useState(null);
  const siteId = useSelector(({ app }) => app.getIn(['config', 'siteId']));

  useEffect(() => {
    // Initialise LazyLoad only if it doesn't exist yet
    if (!lazyLoad) setLazyLoad(new LazyLoad(options(siteId)));

    // Clean up on unmount
    return () => lazyLoad && lazyLoad.destroy();
  }, [lazyLoad]);

  // Expose our LazyLoad API to its children components
  return <Context.Provider value={lazyLoad}>{children}</Context.Provider>;
};

export const withLazyLoadConsumer = (Component) => (props) =>
  <Context.Consumer>{(context) => <Component {...props} lazyLoad={context} />}</Context.Consumer>;

export default LazyLoadProvider;
